import React from 'react';

class ProfileComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false
    };
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.closeDropDown);
  }

  openDropDown = () => {
    if (!this.state.isOpen) {
      this.setState({isOpen: true});
      document.addEventListener('click', this.closeDropDown);
    }
  };

  closeDropDown = () => {
    if (this.state.isOpen) {
      this.setState({isOpen: false});
      document.removeEventListener('click', this.closeDropDown);
    }
  };

  getDropDownContent = () => {
    const {logOut} = this.props;

    if (this.state.isOpen) {
      return <div className='profile-dropDown-item' onClick={logOut}>
        <div>Log out</div>
      </div>;
    } else {
      return null;
    }
  };

  render() {
    const {user} = this.props;

    return (
      <div className={`profile ${this.state.isOpen ? 'open' : ''}`} onClick={this.openDropDown}>
        <div>
          {`${user.firstName} ${user.lastName}`}
        </div>
        {this.getDropDownContent()}
      </div>
    );
  }
}

export default ProfileComponent;



// WEBPACK FOOTER //
// ./src/app/Routing/Header/Profile.jsx